var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"right-in"}},[(_vm.dialog)?_c('div',{attrs:{"id":"key-info"}},[_c('overview',{attrs:{"data":_vm.keyData}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }